export const environment = {
  production: false,
  port: 'http://localhost:8082',
};
